<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />

    <div v-if="featureStore.images.length === 0">
      <FeatureInitSection
        include-uploader
        include-bulk-introducer
        :feature="featureStore.feature"
        :intro-count="2"
        :sample-count="3"
      />
      <PageRestoreOldPhoto />
    </div>

    <div v-else class="h-full">
      <LayoutDefault show-cost :total-cost="totalCost" @finished="onFinished">
        <!--        <template #aside>-->
        <!--          <form>-->
        <!--            <fieldset :disabled="featureStore.processing" class="flex flex-col space-y-6">-->
        <!--              <div class="flex lg:flex-col gap-4">-->
        <!--                <div>-->
        <!--                  <input-->
        <!--                    id="high-resolution"-->
        <!--                    type="checkbox"-->
        <!--                    v-model="featureStore.options[slug].highResolution"-->
        <!--                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"-->
        <!--                  />-->
        <!--                  <label for="high-resolution" class="text-base font-medium text-gray-900 dark:text-gray-300">-->
        <!--                    High resolution-->
        <!--                  </label>-->
        <!--                </div>-->
        <!--                <div>-->
        <!--                  <input-->
        <!--                    id="with-scratch"-->
        <!--                    type="checkbox"-->
        <!--                    v-model="featureStore.options[slug].withScratch"-->
        <!--                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"-->
        <!--                  />-->
        <!--                  <label for="with-scratch" class="text-base font-medium text-gray-900 dark:text-gray-300">-->
        <!--                    With scratch-->
        <!--                  </label>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </fieldset>-->
        <!--          </form>-->
        <!--        </template>-->
      </LayoutDefault>
    </div>
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import { useCostCalculate } from '$/composables/useCostCalculate'
  import PageRestoreOldPhoto from '&/landing_pages/PageRestoreOldPhoto.vue'
  import FeatureMeta from '&/FeatureMeta.vue'

  const { ready, router, featureStore, watchTaskOptions, LayoutDefault, FeatureInitSection } = useFeatureSetup()
  const { totalCost } = useCostCalculate()

  function onFinished() {
    router.push({ name: 'RestoreOldPhotoResult' })
  }

  watchTaskOptions()
</script>
